import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Stack, Tooltip } from '@chakra-ui/react';
import { observer } from 'mobx-react';
import ViewerDialogAssetContent from "./hotspot/asset"




const ViewerHotspotDialog = (props) => {

    // const [associatedName, setAssociatedName] = useState<string>();

    // useEffect(() => {


    //     setAssociatedName(props.builderStore.currentHotspot?.linkedAsset! !== "" ? props.builderStore.currentHotspot?.linkedAsset : "No Asset!");
    // }, [props.builderStore.currentHotspot])


    return (

        <Modal isOpen={props.open} onClose={props.handleClose} motionPreset="slideInBottom" blockScrollOnMount={false} autoFocus={false} size={'6xl'} returnFocusOnClose={false} isCentered scrollBehavior={'inside'}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Asset Details </ModalHeader>
                <ModalCloseButton />
                <ModalBody overflowX={'hidden'} >
                    <ViewerDialogAssetContent handleClose={props.handleClose} userId={props.userId} viewerStore={props.builderStore}  />
                </ModalBody>
            </ModalContent>
        </Modal>

    )
}

ViewerHotspotDialog.propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.any,
    hotspotType: PropTypes.string,
    userId: PropTypes.any,
    builderStore: PropTypes.any
}

export default observer(ViewerHotspotDialog)